export * from "./LabelText";
